import React from 'react';
import { DateRangePicker, DateRangePickerProps } from 'components/common/dates';
import { Grid } from 'antd';
import dayjs from 'dayjs';

const DateRangeFiled: React.FC<DateRangePickerProps> = (props) => {
  const breaks = Grid.useBreakpoint();
  const isNarrow = breaks.xs || !breaks.sm;

  const disabledDate = (current: dayjs.Dayjs) => {
    // Can not select days before today
    return current && current <= dayjs().endOf('day').subtract(1, 'day');
  }

  return (
    <DateRangePicker
      {...props}
      disabledDate={disabledDate}
      dropdownClassName={isNarrow ? 'narrow-picker' : ''}
      placeholder={['Arrival Date', 'Departure Date']}
      style={{width: '100%'}}
      inputReadOnly
    />
  );
};

export default DateRangeFiled;
